import { Box, Button, Checkbox, IconButton, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import { useCallback, useMemo, useState } from "react";
import { InputProdutoSazonalidade } from ".";
import DialogCrudSazonalidade from "./DialogCrudSazonalidade";
import DeleteIcon from '@mui/icons-material/Delete';

export default function SelecaoSazonalidade({
    produtos,
    onChangeCheckbox,
    onVincular,
}: SelecaoSazonalidadeProps) {
    const modalDefaultValue = useMemo(() => ({
        modalState: false,
        data: null
    }), [])

    const [openModal, setOpenModal] = useState<TOpenModalSazonalidade>(modalDefaultValue)

    //funções manipuladoras
    const handleOpenModal = useCallback((action: "create" | "close" | "edit", value?: TOpenModalSazonalidade) => {
        if (action === "edit" && value) setOpenModal(value)
        if (action === "close") setOpenModal(modalDefaultValue)
        if (action === "create") setOpenModal({ ...modalDefaultValue, modalState: true })
    }, [modalDefaultValue])

    return (
        <>
            {
                produtos.length <= 0 &&
                <>
                    <Typography variant="h6">Vincular produtos</Typography>

                    <Box
                        mt={1}
                        width="100%"
                        height={200}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        border="1px solid #005540"
                        borderRadius={1}
                    >
                        <Typography fontWeight="bold" mb={1}>Nenhum produto vinculado a sazonalidade</Typography>
                        <Button
                            startIcon={<AddIcon />}
                            variant="contained"
                            onClick={() => handleOpenModal("create")}
                        >
                            Adicionar
                        </Button>
                    </Box>
                </>
            }
            {
                produtos.length > 0 &&
                <>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6">Produtos Vinculados</Typography>
                        <Button
                            startIcon={<AddIcon />}
                            variant="outlined"
                            onClick={() => handleOpenModal("create")}
                        >
                            Adicionar
                        </Button>
                    </Box>
                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Código</b></TableCell>
                                    <TableCell><b>Nome</b></TableCell>
                                    <TableCell align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    produtos.map((item, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {item.codigo}
                                                </TableCell>
                                                <TableCell>
                                                    {item.nome}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        aria-label="delete"
                                                        onClick={() => onChangeCheckbox(item.codigo, item.nome, false)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
            {
                openModal.modalState &&
                <DialogCrudSazonalidade
                    {...{ onChangeCheckbox, onVincular }}
                    open={openModal.modalState}
                    handleClose={() => handleOpenModal("close")}
                />
            }
        </>
    )
}

interface SelecaoSazonalidadeProps {
    produtos: InputProdutoSazonalidade[]
    onChangeCheckbox: (codigo: number, nome: string, valor: boolean) => void
    onVincular: (produtos: InputProdutoSazonalidade[]) => void
}

export type TOpenModalSazonalidade = {
    modalState: boolean,
    data: TOpenModalSazonalidadeData
}

export type TOpenModalSazonalidadeData = InputProdutoSazonalidade & { index: number } | null
